import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import CarIcon from "@public/images/icons/CarIcon.svg";
import GarageIcon from "@public/images/icons/Garage.svg";
import {
  Card,
  Section,
  IconContainer,
  IconWrapper,
  ContentWrapper,
  LabelText,
  ValueText,
  Separator
} from "./styles";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const DeliveryDetailsCard = (props: any) => {
  const {
    is_visible,
    delivery_address_label,
    delivery_address,
    customer_mobile_label,
    customer_mobile
  } = props;

  if (!is_visible) return <></>;

  return (
    <Card>
      <Section>
        <IconContainer>
          <IconWrapper>
            <CarIcon width={24} height={24} />
          </IconWrapper>
        </IconContainer>
        <ContentWrapper>
          <LabelText>{delivery_address_label}</LabelText>
          <ValueText>{delivery_address || ""}</ValueText>
        </ContentWrapper>
      </Section>
      <Separator />
      <Section>
        <IconContainer>
          <IconWrapper>
            <GarageIcon width={24} height={24} />
          </IconWrapper>
        </IconContainer>
        <ContentWrapper>
          <LabelText>{customer_mobile_label}</LabelText>
          <ValueText>{customer_mobile || ""}</ValueText>
        </ContentWrapper>
      </Section>
    </Card>
  );
};

export default connect(mapStateToProps)(DeliveryDetailsCard);
